'use strict';

// Find all the RoundBox Grids on the page
const grids = document.querySelectorAll('.roundbox-grid'),
    gridsArr = [...grids],
    // For each Grid, find the rows with animated images
    animatedArr = gridsArr.map((grid) => {
        const animatedList = grid.querySelectorAll(
            '.rg-animated .roundbox-grid-imgs'
        );
        // Randomize the animation order unless specified otherwise
        return grid.hasAttribute('data-no-random-animation')
            ? [...animatedList]
            : [...animatedList].sort(() => Math.random() - 0.5);
    });

const toggle = (rows) => {
    for (let i = 0; i <= rows.length; i++) {
        setTimeout(() => {
            if (i === rows.length) {
                // Rerun the function to restart the animation loop
                toggle(rows);
            } else {
                const children = rows[i].querySelectorAll('div'),
                    childrenArr = [...children];
                // Add or remove the class 'inactive' from the <div> holding each background-image
                childrenArr.forEach((c) => {
                    c.classList.toggle('inactive');
                });
            }
            // Create a 2s delay between each row's animation
            // Actual delay is 2s minus the animation duration
            // In this case there's a 1s duration, so a 1s delay
        }, 2000 * i);
    }
};

// Start the animations 3s after the script runs
setTimeout(() => {
    // Run the animation function for each grid
    animatedArr.forEach((rows) => toggle(rows));
}, 3000);
